import React from 'react';
import Table from 'react-bootstrap/Table';
import Scroll from 'react-scroll';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Select from 'react-select';
import { FaPencilAlt } from 'react-icons/fa';
import Modal from 'react-bootstrap/Modal';

import CompanyAPI from '../api/CompanyAPI';
import ApiUiController from '../controller/ApiUiController';

class CompanyUserPage extends React.Component {

  constructor(props) {
    super(props);
    this.id = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    this.Status = [ { label: 'Active', value: 1 }, { label: 'Deleted', value: 2 }, { label: 'Deactive', value: 3 } ];
    this.state = { inApiCall: false, show: false, status: '', name: '', user: {}, users: [] };
  }

  componentDidMount() {
    this.loadUsers();
  }

  clearUsers = () => {
    const body = { client_id: this.id, filter: { status: '', name: '' }, limit: 200, page: 1 };
    this.setState({ ...this.state, status: '', name: '', inApiCall: true });
    CompanyAPI.userList(this.id, body, this.onResponse, this.onFail);
  }

  loadUsers = () => {
    const body = { client_id: this.id,
      filter: { status: this.state.status ? this.state.status.value : 0, name: this.state.name },
      limit: 200, page: 1 };
    this.setState({ ...this.state, users: [], inApiCall: true });
    CompanyAPI.userList(body, this.onResponse, this.onFail);
  }

  onResponse = res => this.setState({ ...this.state, users: res.data, inApiCall: false });

  onFail = () => {
    this.setState({ ...this.state, inApiCall: false });
  }

  onHide = () => this.setState({ ...this.state, show: false });
  onEdit = index => this.setState({ ...this.state, show: true, user: { ...this.state.users[index] } });

  onSave = () => {
    const body = { ...this.state.user };
    this.setState({ ...this.state, show: false, inApiCall: true });
    CompanyAPI.userUpdate(body, this.loadUsers, this.onFail);
  }

  render() {
    let rows = <tr><td colSpan="10">No records Found</td></tr>;
    if(this.state.users.length > 0) {
      rows = this.state.users.map((user, i) =>
        <tr key={`user_${i}`}>
          <td>{user.id}</td>
          <td>{user.user_id}</td>
          <td>{user.username}</td>
          <td>{user.phone}</td>
          <td>{user.email}</td>
          <td>{this.Status.find(type => type.value === user.status).label}</td>
          <td>
            <FaPencilAlt className="actionbtne" onClick={() => this.onEdit(i)} />
          </td>
        </tr>
      );
    }
    return (
      <div>
        <h1>User List</h1>

        <Modal aria-labelledby="contained-modal-title-vcenter" size="lg" className="w-660" centered
          show={this.state.show} onHide={this.onHide} onExit={() => this.onHide}>

          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Edit User Info</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form key="form">
              <div className="row">
                <Form.Group as={Col}>
                  <label>Username</label>
                  <FormControl className="name" type="text" value={this.state.user.username}
                    onChange={event => this.setState({ ...this.state, 
                      user: { ...this.state.user, username: event.target.value } })} />
                </Form.Group>
                <Form.Group as={Col}>
                  <label>Password</label>
                  <FormControl className="name" type="text" value={this.state.user.password}
                    onChange={event => this.setState({ ...this.state, 
                      user: { ...this.state.user, password: event.target.value } })} />
                </Form.Group>
                <Form.Group as={Col}>
                  <Scroll.Element name="name" />
                  <label>Status</label>
                  <Select value={this.Status.find(type => type.value === this.state.user.status)} options={this.Status}
                    onChange={seletced => this.setState({ ...this.state, 
                    user: { ...this.state.user, status: seletced.value } })} />
                </Form.Group>
              </div>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.onSave}>Submit</Button>
          </Modal.Footer>
        </Modal>

        <div>
          <h3>Search</h3>
        </div>
        <Form className="row row-cols-3 lead-form">
          <Form.Group as={Col}>
            <Scroll.Element name="name" />
            <label>Text</label>
            <FormControl className="name" type="text" value={this.state.name}
              onChange={event => this.setState({ ...this.state, name: event.target.value })} />
          </Form.Group>

          <Form.Group as={Col}>
            <Scroll.Element name="type" />
            <label>CRM Type</label>
            <Select value={this.state.status} options={this.Status}
              onChange={seletced => this.setState({ ...this.state, status: seletced })} />
          </Form.Group>

          <Form.Group as={Col}>
            <Button onClick={this.clearUsers} className="btnsub btn btn-primary btn-lg btn-block"> Clear </Button>
            <Button onClick={this.loadUsers} className="btnsub btn btn-primary btn-lg btn-block"> Search </Button>
        </Form.Group>
        </Form>

        <Table striped bordered hover className="table-cursor">
          <thead>
            <tr>
              <th>Id</th>
              <th>User Id</th>
              <th>Username</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <ApiUiController inApiCall={this.state.inApiCall}>  
            <tbody>{rows}</tbody>
          </ApiUiController>
        </Table>
      </div>
    );
  }
}
export default CompanyUserPage;
